import { styled, Box } from "~/common/mui";

export const Root = styled(Box)({
  position: "relative",
  width: "100%",
  "& .react-swipe-container": {
    width: "100%",
  },
});

export const ControlsClassic = styled(Box)(({ theme }) => ({
  marginTop: 12,
  [theme.breakpoints.up("desktop-s")]: {
    marginTop: 20,
  },
  display: "grid",
  gridTemplate: `"leftArrow pagination rightArrow" auto / auto auto auto`,
  justifyContent: "center",
  alignItems: "center",
}));

export const ControlsInside = styled(Box)({
  display: "grid",
  gridTemplate: `"space pagination moreSpace leftArrow rightArrow" auto / 33% 33% 1fr auto auto`,
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
});

export const LeftArrow = styled(Box)({
  gridArea: "leftArrow",
  display: "flex",
  alignItems: "center",
});

export const RightArrow = styled(Box)({
  gridArea: "rightArrow",
  display: "flex",
  alignItems: "center",
});

export const Pagination = styled(Box)({
  gridArea: "pagination",
  margin: "0 10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
});

export const PaginationInsideWrapper = styled(Pagination)({
  marginBottom: 4,
});

export const PaginationItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "variant",
})<{ active?: boolean; variant?: "default" | "inside" }>(({ theme, active, variant }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  cursor: active ? "default" : "pointer",
  // Default variant
  ...(variant !== "inside" && {
    background: active ? theme.palette.primary.main : theme.palette.text.primary,
    "&:hover": {
      background: active ? theme.palette.primary.dark : theme.palette.action.hover,
    },
  }),
  // Inside variant
  ...(variant === "inside" && {
    background: active ? theme.palette.primary.main : theme.palette.common.white,
    "&:hover": {
      background: active ? theme.palette.primary.dark : theme.palette.action.hover,
    },
  }),
}));

export const InsideArrow = styled(Box)({
  background: "rgba(255, 255, 255, 0.5)",
  height: 32,
  width: 32,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const InsideLeftArrow = styled(InsideArrow)({
  marginRight: 4,
  gridArea: "leftArrow",
});

export const InsideRightArrow = styled(InsideArrow)({
  gridArea: "rightArrow",
});
